import { SearchOptionModel } from "@alfresco/aca-shared/store";

/**
 * Enumeración que representa los identificadores únicos para opciones de búsqueda personalizadas.
 * @enum {CustomSearchOptionIds}
 */
export enum CustomSearchOptionIds {
  Files = 'content',
  Folders = 'folder',
  Libraries = 'libraries',
  InThisPath = 'inThisPath'
}

/**
 * Interfaz que representa una opción de búsqueda personalizada.
 * @interface CustomSearchOptionModel
 */
export interface CustomSearchOptionModel extends Omit<SearchOptionModel, 'id'>  {
  id: CustomSearchOptionIds;
}
